import clsx from "clsx";
import React, { useEffect, useRef } from "react";

interface RadioProps
  extends React.DetailedHTMLProps<
    React.InputHTMLAttributes<HTMLInputElement>,
    HTMLInputElement
  > {
  options?: { label: string; value: any }[];
  value?: any;
}
export const Radio: React.FC<RadioProps> = ({ options, value, ...props }) => {
  return (
    <div className="flex flex-col gap-x-8 flex-wrap gap-y-3 items-start mt-3">
      {options!.map((option, idx) => {
        return (
          <label
            key={option.value}
            className="flex items-center gap-x-3 text-sm font-medium cursor-pointer"
          >
            <input type="radio" value={option.value} {...props} />
            <div>{option.label}</div>
          </label>
        );
      })}
    </div>
  );
};
